var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoPetroprix({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 67 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2B373B",
    d: "M33.89 66.47a32.77 32.77 0 0 1-21.1-7.67A32.89 32.89 0 0 1 .97 33.48 33 33 0 0 1 32.15.58l2.42-.05c5.81.12 11.34 1.7 16.18 4.6a8.46 8.46 0 0 1-9.66 3.82 24.4 24.4 0 0 0-6.52-1l-2.17.06a25.4 25.4 0 0 0-18.05 9.13 25.5 25.5 0 0 0-5.93 16.38 25.69 25.69 0 0 0 25.53 25.6h.6a25.6 25.6 0 0 0 24.87-28.43 8.44 8.44 0 0 1 5.44-8.85 33.04 33.04 0 0 1-5.5 32.83A32.87 32.87 0 0 1 34.73 66.5l-.84-.03Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C42833",
    d: "M65.04 14.13a10.26 10.26 0 0 1-8.45-8.45.7.7 0 0 0-.71-.59.73.73 0 0 0-.71.6 10.26 10.26 0 0 1-8.45 8.44.7.7 0 0 0-.6.72c0 .34.26.65.6.71 4.35.72 7.73 4.13 8.45 8.45a.7.7 0 0 0 .71.6c.34 0 .65-.26.68-.6a10.26 10.26 0 0 1 8.45-8.45.7.7 0 0 0 .6-.71.66.66 0 0 0-.57-.72Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B373B",
    d: "M49.36 30.1c0 6.96-5.6 12.52-12.8 12.52h-5.5V54.1a8.34 8.34 0 0 1-8.35-8.36v-28.2h13.82c7.27 0 12.83 5.6 12.83 12.55Zm-8.36 0c0-2.67-1.9-4.7-4.44-4.7h-5.5v9.39h5.5c2.58 0 4.44-2.05 4.44-4.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPetroprix);
export default __webpack_public_path__ + "static/media/logo-petroprix.970c0465560d20834ae6d23b59ebc58a.svg";
export { ForwardRef as ReactComponent };